/* eslint-disable import/first */
import React from 'react';
import './DemoWorkspace.css';
import SalaryTable from './SalaryTable';
import FilteredBarChart from './FilteredBarChart';
import AIAgent from './AIAgent';
import Consultant from './Consultant';
import ExcelReports from './ExcelReports';

const initialCompanies = [
  { id: '1',  name: 'Family Office #1',  type: 'Family Office', aum: 8.5,  salary: 335000, bonus: 195, carry: 0, checked: true, grade: 'Senior' },
  { id: '2',  name: 'Family Office #2',  type: 'Family Office', aum: 6.8,  salary: 345000, bonus: 205, carry: 0, checked: true, grade: 'Senior' },
  { id: '3',  name: 'Private Equity #1', type: 'PE',            aum: 7.4,  salary: 390000, bonus: 240, carry: 0, checked: true, grade: 'Senior' },
  { id: '4',  name: 'Private Equity #2', type: 'PE',            aum: 4.4,  salary: 325000, bonus: 185, carry: 0, checked: true, grade: 'Senior' },
  { id: '5',  name: 'Private Equity #3', type: 'PE',            aum: 4.6,  salary: 315000, bonus: 175, carry: 0, checked: true, grade: 'Senior' },
  { id: '6',  name: 'Private Equity #4', type: 'PE',            aum: 3.7,  salary: 285000, bonus: 145, carry: 0, checked: true, grade: 'Senior' },
  { id: '7',  name: 'Private Equity #5', type: 'PE',            aum: 0.9,  salary: 215000, bonus:  80, carry: 0, checked: true, grade: 'Senior' },
  { id: '8',  name: 'Private Equity #6', type: 'PE',            aum: 1.9,  salary: 230000, bonus:  90, carry: 0, checked: true, grade: 'Senior' },
  { id: '9',  name: 'Family Office #3',  type: 'Family Office', aum: 2.4,  salary: 240000, bonus: 100, carry: 0, checked: true, grade: 'Senior' },
  { id: '10', name: 'Private Equity #7', type: 'PE',            aum: 2.7,  salary: 260000, bonus: 120, carry: 0, checked: true, grade: 'Senior' },
  { id: '11', name: 'Private Equity #8', type: 'PE',            aum: 3.2,  salary: 300000, bonus: 160, carry: 0, checked: true, grade: 'Senior' },
  { id: '12', name: 'Private Equity #9', type: 'PE',            aum: 2.8,  salary: 270000, bonus: 130, carry: 0, checked: true, grade: 'Senior' },
  { id: '13', name: 'Family Office #4',  type: 'Family Office', aum: 3.4,  salary: 305000, bonus: 165, carry: 0, checked: true, grade: 'Senior' },
  { id: '14', name: 'Family Office #5',  type: 'Family Office', aum: 2.5,  salary: 250000, bonus: 110, carry: 0, checked: true, grade: 'Senior' },
  { id: '15', name: 'Family Office #6',  type: 'Family Office', aum: 0.8,  salary: 200000, bonus:  65, carry: 0, checked: true, grade: 'Senior' },
  { id: '16', name: 'Family Office #7',  type: 'Family Office', aum: 0.7,  salary: 185000, bonus:  55, carry: 0, checked: true, grade: 'Senior' },
  { id: '17', name: 'Family Office #8',  type: 'Family Office', aum: 12.0, salary: 355000, bonus: 215, carry: 0, checked: true, grade: 'Senior' },
  { id: '18', name: 'Family Office #9',  type: 'Family Office', aum: 9.2,  salary: 370000, bonus: 225, carry: 0, checked: true, grade: 'Senior' },
  { id: '19', name: 'Family Office #10', type: 'Family Office', aum: 2.9,  salary: 275000, bonus: 135, carry: 0, checked: true, grade: 'Senior' },
  { id: '20', name: 'Private Equity #10',type: 'PE',            aum: 3.9,  salary: 295000, bonus: 155, carry: 0, checked: true, grade: 'Senior' },
];

const DemoWorkspace: React.FC = () => {
  const [tableFilteredCount, setTableFilteredCount] = React.useState<number>(initialCompanies.length);
  
  // Состояние для фильтров диаграммы
  const [chartSelectedFilter, setChartSelectedFilter] = React.useState<string>('all');
  const [chartSelectedAumFilter, setChartSelectedAumFilter] = React.useState<string>('all');
  const [chartSelectedDataType, setChartSelectedDataType] = React.useState<string>('salary');

  // Функция для фильтрации компаний по фильтрам диаграммы
  const getChartFilteredCompanies = () => {
    let filtered = initialCompanies;
    
    // Фильтр по типу
    switch (chartSelectedFilter) {
      case 'pe':
        filtered = filtered.filter(company => company.type === 'PE');
        break;
      case 'fo':
        filtered = filtered.filter(company => company.type === 'Family Office');
        break;
      case 'all':
      default:
        break;
    }
    
    // Фильтр по AUM
    switch (chartSelectedAumFilter) {
      case 'large':
        filtered = filtered.filter(company => company.aum >= 5);
        break;
      case 'medium':
        filtered = filtered.filter(company => company.aum >= 3 && company.aum < 5);
        break;
      case 'small':
        filtered = filtered.filter(company => company.aum >= 1 && company.aum < 3);
        break;
      case 'tiny':
        filtered = filtered.filter(company => company.aum < 1);
        break;
      case 'all':
      default:
        break;
    }
    
    return filtered;
  };

  const chartFilteredCompanies = getChartFilteredCompanies();

  return (
    <div className="demo-workspace">
      <h2 className="workspace-step-title">Шаг 1. Ознакомьтесь с аналитикой на платформе ({tableFilteredCount} компаний)</h2>
      <SalaryTable companies={initialCompanies} onFilteredCountChange={setTableFilteredCount} />
      
      <div className="dashboards-step-container">
        <h2 className="dashboards-step-title">Шаг 2. Работайте со стандартными дашбордами или формируйте собственные</h2>
      </div>
      <FilteredBarChart 
        companies={initialCompanies}
        selectedFilter={chartSelectedFilter}
        selectedAumFilter={chartSelectedAumFilter}
        selectedDataType={chartSelectedDataType}
        onFilterChange={setChartSelectedFilter}
        onAumFilterChange={setChartSelectedAumFilter}
        onDataTypeChange={setChartSelectedDataType}
      />
      
      <div className="dashboards-step-container">
        <h2 className="dashboards-step-title">Шаг 3. Ознакомьтесь с выводами от помощника datacircle-ai</h2>
      </div>
      
      <AIAgent companies={chartFilteredCompanies} />
      
      <div className="dashboards-step-container">
        <h2 className="dashboards-step-title">Шаг 4. Обсудите результаты с консультантом Вашего проекта</h2>
      </div>
      
      <Consultant />
      
      <div className="dashboards-step-container">
        <h2 className="dashboards-step-title">Шаг 5. Сгенерируйте и сохраните нужные отчеты</h2>
      </div>
      
      <ExcelReports />
    </div>
  );
};

export default DemoWorkspace; 